import React from 'react'

import styled from 'styled-components'

import { color } from 'styles/colors'
import { screenSize } from 'styles/shared'

type Props = React.PropsWithChildren<{
  className?: string
  pingdomId?: string
  id?: string
  scrollToSection?: boolean
}>

const Panel = ({ children, className, pingdomId, id, scrollToSection }: Props) => <S.Panel data-scroll-to-section={scrollToSection} data-pingdomid={pingdomId} {...{ className, id }}>{children}</S.Panel>
const Title = ({ children, className }: Props) => <S.Title {...{ className }}>{children}</S.Title>
const Header = ({ children, className }: Props) => <S.Header {...{ className }}>{children}</S.Header>
const HeaderLeft = ({ children, className }: Props) => <S.HeaderLeft {...{ className }}>{children}</S.HeaderLeft>

Panel.Title = Title
Panel.Header = Header
Header.Left = HeaderLeft

export { Panel }

const S = {
  Panel: styled.div`
    border-bottom: 0.6px solid ${color('borderGray')};
    width: calc(100% - 40px);
    margin: 0 auto;
    padding: 20px 0;
    @media ${screenSize.small} {
      width: 100%;
      padding: 10px 0;
    }
  `,
  Title: styled.span`
    font-weight: bold;
    white-space: nowrap;
    font-size: 20px;
    display: flex;
  `,
  Header: styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    color: ${color('primaryText')};
    margin-bottom: 10px;

    @media ${screenSize.small} {
      top: 45px;
      z-index: 1;
      background-color: ${color('paneBackground')};
    }
  `,
  HeaderLeft: styled.div`
    display: flex;
    gap: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `
}
